import { RateType as GQLRateType } from '@/gql/graphql'
/**
 * Relates to old form submissions
 * For GQL, use GQLRateType
 */
export enum RateType {
  HOURLY = 'hourly',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  FIXED = 'fixed',
  UNKNOWN = 'unknown',
}

// Maps RateType to GQLRateType or vis versa
export const mapRateTypeEnum = (value: RateType | GQLRateType): RateType | GQLRateType => {
  if (value in RateType) {
    return GQLRateType[Object.keys(RateType)[Object.values(RateType).indexOf(value as RateType)]]
  }

  if (value in GQLRateType) {
    return RateType[
      Object.keys(GQLRateType)[Object.values(GQLRateType).indexOf(value as GQLRateType)]
    ]
  }

  throw new Error(`Invalid rate type "${value}"`)
}
